export default {
  'moduleTitle.address': 'Adresa',
  'moduleTitle.address_details': 'Detalii adresă',
  'moduleTitle.activity_details': 'Detalii activitate',
  'moduleTitle.add_log': 'Adaugă notă',
  'moduleTitle.award_level': 'Nivel Award',
  'moduleTitle.adventurous_journey': 'Aventură',
  'moduleTitle.already_assessed': 'Deja evaluat!',
  'moduleTitle.approved': 'Aprobat!',
  'moduleTitle.assessor_details': 'Detalii Evaluator',
  'moduleTitle.authorising_contact_license_holder': 'Unitate Award',
  'moduleTitle.category_journey_details': 'Detalii călătorie',
  'moduleTitle.complete_report': 'Completează raport',
  'moduleTitle.completed_progress': 'Finalizat {finished} / {total}',
  'moduleTitle.congratulation': 'Felicitări!',
  'moduleTitle.confirming_email_address': 'Adresa de email se confirmă...',
  'moduleTitle.contact_details': 'Detalii contact',
  'moduleTitle.edit_log': 'Editare notă',
  'moduleTitle.event_journey': '{event} Călătorie',
  'moduleTitle.forgotten_password': 'Am uitat parola',
  'moduleTitle.great_you_are_almost_there': 'Bravo, aproape ai ajuns. Ultimul pas este plata pentru noul nivel.',
  'moduleTitle.home_address': 'Adresa de domiciliu',
  'moduleTitle.journey_overview': 'Descriere călătorie',
  'moduleTitle.log_detail': 'Detalii notă de jurnal',
  'moduleTitle.login': 'Conectare',
  'moduleTitle.new_activity': 'Activitate nouă',
  'moduleTitle.new_event_journey': '{event} Călătorie nou',
  'moduleTitle.new_residential_project': 'Proiect Rezidențial nou',
  'moduleTitle.notRegistred': 'Nu ești înregistrat?',
  'moduleTitle.nominated_award_leader_contact_details': 'Date de contact Lider Award desemnat',
  'moduleTitle.nominated_award_leader': 'Lider Award desemnat',
  'moduleTitle.organisation_address': 'Adresă organizație',
  'moduleTitle.organisation_details': 'Detalii organizație',
  'moduleTitle.online_record_book_account': 'Cont Online Record Book',
  'moduleTitle.page_not_found': '404 - Pagina nu este găsită',
  'moduleTitle.personal_details': 'Detalii personale',
  'moduleTitle.preparation_and_training': 'Pregătire și Training',
  'moduleTitle.profile_guardian_consent': 'Acordul părinte/tutore',
  'moduleTitle.profile_questions': 'Întrebări de profil',
  'moduleTitle.registration_for_level': 'Înregistrare pentru nivelul următor',
  'moduleTitle.residential_project': 'Proiect Rezidențial',
  'moduleTitle.residential_project_details': 'Detalii Proiect Rezidențial',
  'moduleTitle.reset_password': 'Resetează parola',
  'moduleTitle.welcome_to_the_orb': 'Bine ai venit la Online Record Book!',
  'moduleTitle.we_have_sent_you_an_email': 'Un email cu link-ul de activare a fost trimis',
  'moduleTitle.your_registration_is_complete': 'Înregistrarea este completă',
  'formTitle.activity_details': 'Detalii activitate',
  'formTitle.assessor_details': 'Detalii Evaluator',
  'formTitle.supervisors_details': 'Detalii Supraveghetor',
  'formTitle.preparation_and_training_activities': 'Activități de pregătire și instruire',
  'formTitle.added_preparation_activities': 'Activități de pregătire și instruire adăugate',
  'label.add_picture': 'Adaugă poză',
  'label.address_first_line': 'Adresa - Rândul 1',
  'label.address_second_line': 'Adresa - Rândul 2 (opțional)',
  'label.are_you_already_running_award': 'Deja livrați programul Award?',
  'label.are_you_the_main_award_leader': 'Sunteți Liderul Principal sau Coordonatorul Unității dvs. Award?',
  'label.award_participant': 'Participant Award',
  'label.award_leader': 'Lider Award',
  'label.birthdate': 'Data nașterii',
  'label.category': 'Categorie',
  'label.change_locale': 'Schimbă locația',
  'label.choose_project': 'Alege activitatea',
  'label.city': 'Oraș',
  'label.choose_as_major_activity': 'Alege ca Activitate lungă',
  'label.date': 'Data',
  'label.date_of_birth': 'Data nașterii',
  'label.description_of_progress': 'Descrierea progresului tău',
  'label.duration': 'Durata (min)',
  'label.email': 'Email',
  'label.email_address': 'Adresa email',
  'label.email_again': 'Confirmă email',
  'label.employment_status': 'Statutul de angajat',
  'label.end_date': 'Data finalizării',
  'label.enter_his_email': 'Introduceți adresa de email',
  'label.entered_transaction_id': 'ID-ul tranzacției tale',
  'label.first_name': 'Prenume',
  'label.gender': 'Sex',
  'label.goal': 'Scop',
  'label.journey_activity': 'Activitate călătorie',
  'label.journey_objective': 'Scopul călătoriei',
  'label.journey_observations': 'Observații călătorie',
  'label.journey_type': 'Tipul călătoriei',
  'label.last_name': 'Numele de familie',
  'label.level': 'Nivel',
  'label.location': 'Locație',
  'label.logout': 'Deconectare',
  'label.major': 'Activitate lungă',
  'label.middle_name': 'Al doilea prenume',
  'label.mode_of_transport': 'Modul de transport',
  'label.my_award_leader': 'Liderul meu Award',
  'label.name': 'Nume',
  'label.nationality': 'Naționalitate',
  'label.no': 'Nu',
  'label.no_results': 'Fără rezultat',
  'label.note': 'Mesaj',
  'label.note_for_assessor': 'Mesaj pentru Evaluator',
  'label.note_for_leader': 'Mesaj pentru Lider',
  'label.optional': 'Opțional',
  'label.organisation_name': 'Numele organizației',
  'label.organisation_type': 'Tipul organizației',
  'label.others': 'Altele',
  'label.password': 'Parolă',
  'label.password_again': 'Repetă parola',
  'label.project_location': 'locația proiectului',
  'label.pay_online': 'Plătește Online',
  'label.pay_award_leader_or_unit': 'Plătește la Liderul Award/Unitate',
  'label.payment_not_required': 'Plata nu este cerută de la participant',
  'label.payment_type': 'Tipul plății',
  'label.phone': 'Telefon',
  'label.phone_number': 'Număr telefon',
  'label.phone_type': 'Tipul telefonului',
  'label.profile': 'Profil',
  'label.reset_password': 'Resetează parola',
  'label.region': 'Stat/Provincie/Regiune',
  'label.relationship': 'Relație',
  'label.role_in_organisation': 'Rol în organizație',
  'label.select_country': 'Selectează țara',
  'label.select_your_au': 'Selectează Unitatea ta Award',
  'label.start_typing': 'Scrie...',
  'label.start_date': 'Data începerii',
  'label.select': 'Selectează',
  'label.select_async': 'Scrie...',
  'label.select_your_operating_authority': 'Selectează Autoritatea ta Operațională',
  'label.specify_category': 'Te rugăm specifică categoria',
  'label.subcategory': 'Subcategoria',
  'label.title': 'Titlu',
  'label.username': 'Nume utilizator',
  'label.what_is_your_role': 'Care este rolul dvs. în organizație?',
  'label.where_have_you_completed': 'Unde ați finalizat?',
  'label.yes': 'Da',
  'label.your_changes_havent_been_saved': 'Modificările tale nu au fost salvate. Datele se vor pierde.',
  'label.zip': 'ZIP / Cod Poștal',
  'label.adventurous_journey': 'Aventura',
  'label.after_your_journey_describe': 'Descrie observațiile tale din călătorie în câteva fraze.',
  'label.because_your_age_is_under_18': 'Deoarece nu ai împlinit 18 ani, avem nevoie de acordul Părintelui / Tutorelui.',
  'label.before_you_head_to_journey': 'Înainte de a continua la Călătoria Finală este necesar să finalizezi etapa Pregătire și Instruire.',
  'label.before_entering_new_level': 'Înainte de a merge la nivelul următor, te rog să confirmi că datele personale sunt încă de actualitate.',
  'label.bring_required_amount_to_your_award_leader': 'Adu necesarul Liderului Award sau Coordonatorului din Unitatea ta.',
  'label.do_you_have_any_other_level': 'Ai finalizat vreun nivel Award anterior?',
  'label.do_you_know_who_is_your_award_leader': 'Știi cine este Liderul tău Award?',
  'label.going_on_an_expedition': 'Expediția îți oferă șansa de a avea parte de o aventură, de a lucra în echipă și de a acționa la propria ta inițiativă.',
  'label.going_on_residential_gives_chance': 'Proiectul Rezidențial îți oferă șansa să înveți cum să lucrezi cu oameni din diferite medii sociale și să îți întărești încrederea locuind în medii noi.',
  'label.i_confirm_that_i_meet': 'Confirm că îndeplinesc toate cerințele reglementate ANA',
  'label.i_agree_to_volunteer_code': 'Sunt de acord cu Codul de Conduită al Voluntarului. Pentru mai multe informații click aici.',
  'label.i_have_read_the_terms_and_conditions': 'Am citit Termenii și condițiile și sunt de acord cu ele.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Voi da Liderului meu Award acordul, mai târziu',
  'label.if_you_are_from_orphanage': 'De exemplu, dacă școala sau organizația ta plătește pentru tine',
  'label.here_you_can_add_activity': 'Aici poți să adaugi în plus activități de Pregătire și Instruire',
  'label.how_do_you_want_to_apply': 'Cum vrei să aplici:',
  'label.my_parent_consent_has_been_already_given': 'Acordul părintelui/tutorelui a fost dat Liderului meu Award.',
  'label.my_parent_will_confirm_consent_by_email': 'Părintele/Tutorele își va da acordul prin email',
  'label.major_activity_means_that_you_have_to_spent': 'Activitate lungă înseamnă că vei petrece de două ori mai mult timp la această activitate, față de celelalte.',
  'label.not_sure_about_your_auth': 'Dacă nu ești sigur la ce Autoritate Award să te înregistrezi, te rugăm să contactezi Biroul Regional.',
  'label.page_not_found': '404 - Pagina nu a fost găsită.',
  'label.please_fill_in_the_following': 'Vă rugăm completați următoarele detalii pentru persoana de contact autorizată / deținătorul licenței din organizația dvs.',
  'label.register_a_new_account_as': 'Înregistrează un nou cont ca:',
  'label.residential_project': 'Proiect Rezidențial',
  'label.select_your_award_unit': 'Selectează Unitatea ta Award',
  'label.the_expedition_can_be_faraway': 'Expediția poate să fie foarte departe sau foarte aproape de casă, depinde cum dorești, sunt multe opțiuni pe care le poți alege.',
  'label.to_log_your_process_on_orb': 'Te rugăm să setezi o parolă pentru a completa crearea contului tău Online Record Book',
  'label.waiting_for_assessment': 'Evaluare în așteptare',
  'label.waiting_for_sign_off': 'Aprobare definitivă de către Liderul Award în așteptare',
  'label.we_have_sent_you_an_email': 'V-am trimis un email cu un link de activare.',
  'label.what_level_of_the_award': 'Pentru ce nivel Award vă înregistrați?',
  'label.you_are_now_registering_as_participant': 'Te înregistrezi ca participant Award.',
  'label.you_are_now_registering_as_award_unit': 'Te înregistrezi ca Unitate Award.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'În calitate de participant Award sunt de acord ca Fundația să folosească fotografii cu mine în scopuri de promovare.',
  'label.you_can_send_activity_for_approval': 'Poți să trimiți activitatea ta Evaluatorului pentru aprobare.',
  'label.you_can_send_activity_for_leader': 'Poți să trimiți activitatea ta Liderului tău pentru aprobare.',
  'label.you_can_send_residential_project_to_leader': 'Poți să trimiți Proiectul Rezidențial către Liderul tău pentru aprobare.',
  'label.you_have_finished_now_send_to_approval': 'Activitatea ta este finalizată. Poți să trimiți către Evaluator pentru aprobare. Poți să adaugi și un mesaj mai jos.',
  'label.preparation_and_training': 'Pregătire și Instruire',
  'label.you_will_be_redirected_to_the_payment': 'O să fii redirecționat către Portalul de plată, unde poți să folosești un card de credit sau debit.',
  'label.you_will_be_the_first_award_leader': 'Ești coordonatorul Award din organizația ta. Poți agăuga Lideri Award, Participanți și să administrezi programul Award prin sistemul Online Record Book.',
  'label.youll_receive_a_notification': 'Vei primi o notificare când Liderul tău a aprobat înregistrarea ta. Te poți autentifica pe Online Record Book <a>aici</a> (până ce înregistrarea ta va fi aprobată de Liderul tău, vei avea acces limitat).',
  'label.your_parent_email': 'Email-ul părintelui / tutorelui',
  'label.your_parent_first_name': 'Prenumele părintelui / tutorelui',
  'label.your_parent_last_name': 'Numele de familie al părintelui / tutorelui',
  'label.your_report_approve_now_send_to_leader': 'Raportul tău a fost aprobat de Evaluator. Îl poți trimite Liderului tău Award pentru aprobare. Poți adăuga un mesaj mai jos.',
  'label.there_are_loads_of_exciting_possibilities': 'Există nenumărate posibilități și oportunități incitante. Alege ceva ce ți se pare satisfăcător.',
  'label.your_residential_project_has_been_setup': 'Proiectul tău Rezidențial a fost configurat și va fi trimis Liderului Award pentru aprobare.',
  'label.your_report_has_been_sent_assessor': 'Raportul tău a fost trimis Evaluatorului pentru aprobare.',
  'label.your_report_has_been_sent_leader': 'Raportul tău a fost trimis Liderului Award pentru aprobare.',
  'label.your_residential_project_is_complete': 'Proiectul tău Rezidențial este finalizat.',
  'label.to_work_on_the_online': 'Pentru a folosi Online Record Book (ORB) ai nevoie de un cont personal ORB.',
  'label.we_will_send_you_an_email': 'Îți vom trimite un email când înregistrarea contului tău este aprobată.',
  'label.if_you_have_any_problems_or_doubts': 'Dacă ai probleme sau îndoieli, te rog contactează unitatea ta award pentru mai multe informații.',
  'label.are_you_sure_you_want_to_leave': 'Ești sigur că vrei să ieși? Datele se vor pierde.',
  'label.no_logs_yet': 'Nu ai note de jurnal adăugate. <br /> Încearcă să adaugi prima notă de jurnal apăsând butonul "Adaugă notă de jurnal".',
  'label.menu': 'Meniu',
  'notifications.award_unit_has_been_created': 'Unitatea Award a fost creată',
  'notifications.authorization_code_is_not_valid': 'Codul de autorizare nu este valid',
  'notifications.email_has_been_confirmed': 'Adresa de email a fost confirmată',
  'notifications.leader_has_been_created': 'Liderul a fost creat',
  'notifications.participant_has_been_created': 'Participantul a fost creat',
  'notifications.email_with_instructions_has_been_sent': 'Un email cu instrucțiuni a fost trimis',
  'notifications.your_new_password_has_been_set': 'Noua ta parolă a fost setată',
  'notifications.success': 'Succes',
  'notifications.unknown_role': 'Rol necunoscut',
  'notifications.waiting_for_approval': 'Aprobare în așteptare',
  'notifications.activity_cannot_be_created': 'Activitatea nu poate fi creată până nu ți se aprobă înregistrarea.',
  'notifications.new_activity_has_been_added': 'Activitatea nouă a fost adăugată',
  'notifications.new_log_has_been_added': 'O notă nouă de jurnal a fost adăugată',
  'notifications.log_has_been_deleted': 'Nota a fost ștearsă',
  'notifications.log_has_been_modified': 'Nota a fost modificată',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Aventura nu poate fi creată până nu ți se aprobă înregistrarea.',
  'notifications.new_participant_event_has_been_added': 'Un eveniment nou al participantului a fost adăugat',
  'notifications.participant_event_has_been_completed': 'Evenimentul Participantului a fost finalizat.',
  'notifications.training_and_practice_modified': 'Pregătirea și Instruirea au fost modificate',
  'notifications.completion_residential_project_completed': 'Proiectul Rezidențial a fost completat',
  'notifications.new_residential_project_has_been_added': 'Proiect Rezidențial nou adăugat',
  'notifications.residential_project_cannot_be_created_until_approved': 'Proiectul Rezidențial nu poate fi creat până când înregistrarea ta nu este aprobată',
  'notifications.already_assessed_sent': 'Cererea de aprobare de către Lider a fost trimisă',
  'notifications.assessment_request_sent': 'Cererea de evaluare a fost trimisă',
  'notifications.leader_approval_sent': 'Cererea de aprobare de către Lider a fost trimisă',
  'tabs.logs': 'Note de jurnal',
  'tabs.new': 'Nou',
  'tabs.overview': 'Prezentare generală',
  'tabs.report': 'Raport',
  'button.add_activity': 'Adaugă activitate',
  'button.add_log': 'Adaugă notă',
  'button.continue_here': 'Continuă aici',
  'button.continue': 'Continuă',
  'button.continue_to_award': 'Continuă la Award',
  'button.delete': 'Ștergere',
  'button.edit': 'Editare',
  'button.edit_log': 'Editare notă',
  'button.finish': 'Finalizare',
  'button.forgot_your_password': 'Ai uitat parola?',
  'button.i_already_have_assessment': 'Am trimis deja o evaluare',
  'button.leave_anyway': 'Renunță',
  'button.login': 'Autentificare',
  'button.no': 'Nu',
  'button.register': 'Înregistrare',
  'button.send': 'Trimite',
  'button.send_for_approval': 'Trimite pentru aprobare',
  'button.setup': 'Configurare',
  'button.setup_residential': 'Configurează Proiectul Rezidențial',
  'button.stay': 'Rămâi',
  'button.submit': 'Trimite',
  'button.update': 'Actualizează',
  'button.yes': 'Da',
  'errors.at_least_num_characters': 'Cel puțin {length} caractere',
  'errors.do_not_match': 'Nu se potrivesc',
  'errors.include_at_least_one_number': 'Include cel puțin o cifră',
  'errors.include_both_lower_and_upper_case': 'Include atât majuscule, cât și litere mici',
  'errors.invalid_phone_format': 'Format număr telefon invalid',
  'errors.invalid_email_address': 'Adresă de email invalidă',
  'errors.required_field': 'Câmp obligatoriu',
  'errors.must_be_at_least': 'Trebuie să conțină minim {min} caractere',
  'errors.must_be_no_more_than': 'Nu trebuie să fie mai mare de {max} caractere',
  'errors.must_be_an_integer': 'Trebuie să fie număr întreg',
  'errors.must_contain_at_least': 'Trebuie să conțină cel puțin o cifră',
  'errors.must_include_at_least': 'Trebuie să includă cel puțin o majusculă',
  'errors.must_be_one_of': 'Trebuie să fie unul dintre: {enums}',
  'errors.you_must_be_younger_than': 'Trebuie să fii mai mic de ani {years} și luni {months} pentru a te înregistra în Award. Te rugăm să contactezi un membru al Unității Award.',
  'errors.you_must_be_older_than': 'Trebuie să fii mai mare de ani {years} și luni {months} pentru a te înregistra în Award. Te rugăm să contactezi un membru al Unității Award.',
  'errors.email_address_is_in_use_please_sign': 'Adresa de email este deja în uz. Dacă vrei să te înregistrezi la un alt nivel, te rog să intri în contul tău.',
  'errors.email_address_is_in_use': 'Adresa de email este deja în uz.',
  'errors.sorry_we_already_have_this_email': "Ne pare rău, exstă deja un cont cu această adresă de email.Dacă vrei să începi următorul nivel, <a href='/'> intră în contul tău </a> și selectează opțiunea Începe Nivelul următor.",
  'wizard.authorising_contact': 'Persoana de contact autorizată',
  'wizard.award_leader_contact': 'Contact Lider Award',
  'wizard.award_unit_details': 'Detalii Unitate Award',
  'wizard.contact_details': 'Detalii contact',
  'wizard.contacts': 'Contacte',
  'wizard.level': 'Nivel Award',
  'wizard.level_selection': 'Selectarea nivelului Award',
  'wizard.leader_details': 'Detalii Lider',
  'wizard.nominated_award_leader': 'Lider Award desemnat',
  'wizard.orb_account': 'Cont ORB',
  'wizard.parent_consent': 'Acordul părintelui',
  'wizard.participant_details': 'Detalii Participant',
  'wizard.profile': 'Profil',
  'wizard.payment': 'Plată',
  'wizard.select_award_unit': 'Selecteazp Unitatea Award',
  'wizard.unit_details': 'Detalii unitate',
  'wizard.welcome': 'Bine ai venit!',
  'wizard.your_details': 'Detaliile tale',
  'awardUnit.do_you_want_to_create': 'Vreți să creați o nouă Unitate Award?',
  'parent.you_can_download_the_consent_here': 'Poți descărca Formularul Acordul Părintelui de aici dacă nu îl ai deja. După ce Părintele/Tutorele a semnat, te rugăm să-l predai Liderului Award.',
  'footer.copyright': "&copy; Copyright The Duke of Edinburgh's International Award {year}",
  'registration_participant.required_award_payment': 'Plata Award necesară',
  'registration_participant.pay_online_here': 'Plătește online și primești ID-ul tranzacției aici.',
  'dashboard.activity_log_time': '{hours}h {minutes}min',
  'moduleTitle.award_completed': 'Program Award finalizat!',
  'notifications.award_approval_request_sent_to_leader': 'Aprobarea programului Award a fost trimisă Liderului tău',
  'notifications.new_participant_event_has_been_completed': 'Un eveniment nou al participantului a fost finalizat',
  'notifications.preparation_and_training_approval_sent': 'Aprobarea pentru Pregătire și instruire a fost trimisă.',
  'notifications.reparation_and_training_completed': 'Pregătirea și instruirea au fost finalizate',
  'notifications.your_profile_photo_has_been_edited': 'Poza ta de profil a fost editată',
  'notifications.your_profile_has_been_edited': 'Profilul tău a fost editat',
  'notifications.new_level_has_started': 'Următorul nivel a început',
  'notifications.activity_has_been_edited': 'Activitatea a fost editată',
  'notifications.you_have_been_logged_out': 'Deconectare...',
  'notifications.logging_out': 'Ai fost deconectat',
  'label.you_can_send_award_to_leader': 'Poți trimite programul Award Liderului tău, pentru aprobare',
  'label.you_have_completed_all_sections_of_your_award': 'Ai finalizat toate secțiunile programului Award. Îl poți trimite acum Liderului tău pentru aprobare. Poți adăuga un mesaj personal mai jos.',
  'label.you_have_now_completed_your_award': 'Ai finalizat {level} al programului Award. Dorești să începi următorul nivel?',
  'label.congratulation_your_award_has_been_approved': 'Felicitări. Nivelul {level} a fost aprobat! <br /> Dacă dorești, poți deja să începi nivelul următor.',
  'moduleTitle.settings': 'Setări',
  'moduleTitle.edit_activity': 'Editează activitatea',
  'moduleTitle.select_your_major_activity': 'Alege Activitatea Lungă',
  'label.settings': 'Setări',
  'label.major_activity_means_that_you_will': 'Activitatea lungă înseamnă că vei petrece mai mult timp pentru această activitate, față de celelalte. Pentru nivelurile de Aur și Argint perioada extra necesară este de 6 luni, pentru Bronz, de 3 luni.',
  'label.notifications': 'Notificări',
  'label.my_award': 'Programul meu Award',
  'label.physical_recreation': 'Activități Fizice',
  'label.skill': 'Abilități Personale',
  'label.service': 'Voluntariat',
  'label.my_parent_will_complete_and_sign_form': 'Părintele / Tutorele meu va completa și semna formularul Acordul Părintelui / Tutorelui',
  'label.please_print_it_tak_it_to_your_parent': 'Te rugăm să-l printezi, să-l dai părintelui/tutorelui să-l semneze și apoi să-l dai Liderului tău Award.',
  'label.change_password': 'Schimbă parola',
  'label.change_major_activity': 'Schimbă Activitatea Lungă',
  'title.change_password': 'Schimbă parola',
  'label.old_again': 'Parola veche',
  'label.new_password': 'Parolă nouă',
  'label.new_password_again': 'Introdu din nou Parola nouă',
  'errors.passwords_dont_match': 'Parolele nu se potrivesc',
  'errors.more_than': 'Mai mult de {limit}',
  'button.parent_guardian_consent_pdf': 'Acordul părintelui/tutorelui.pdf',
  'button.send_award_for_approval': 'Trimite programul Award pentru aprobare',
  'button.send_report': 'Trimite raport',
  'button.terms_and_conditions': 'Termeni și Condiții Internaționale',
  'button.privacy_policy': 'Politica de confidențialitate',
  'button.save': 'Salvează',
  'button.start_new_level': 'Începe nivelul următor',
  'button.change_password': 'Schimbă parola',
  'button.edit_activity': 'Editează activitatea',
  'moduleTitle.file_upload': 'Încărcare fișier',
  'label.add_file': 'Adaugă fișier',
  'label.description': 'Descriere',
  'label.waiting_for_office_sign_off': 'Aprobarea finală de la Biroul Award în așteptare',
  'notifications.file_has_been_uploaded': 'Fișierul a fost încărcat',
  'tabs.files': 'Fișiere',
  'button.upload': 'Încarcă',
  'button.upload_file': 'Încarcă fișier',
  'button.add_file': 'Adaugă fișier',
  'button.this_activity_has_no_assessor': 'Această activitate nu are evaluator. Trebuie să adaugi detaliile evaluatorului înainte de a o trimite pentru aprobare.',
  'label.i_want_to_register_my_award': 'Vreau să-mi înregistrez Unitatea Award ca Centru Award Independent',
  'label.select_sub_operating_authority': 'Selectează Autoirtatea Sub-operațională',
  'label.your_must_first_setup_some_activity': 'Înainte trebuie să configurezi activități',
  'label.you_cant_change_your_major_activity': 'Nu-și poți schimba Activitatea Lungă. Activitatea Lungă a fost deja finalizată.',
  'label.s_specific': '<b>S-Specific: Scopul tău nu trebuie să fie prea general. </b> În loc să spui ”Vreau să fiu mai bun la vioară”, poți spune ”Vreau să stăpânesc gama La Minor la vioară”.',
  'label.m_measurable': '<b>M-Măsurabil: Trebuie să poți spune când ți-ai atins scopul. <b> În loc să spui ”Vreau să ajut comunitatea”, ai putea spune ”Vreau să ajut oamenii care merg la cantinele de săraci, făcând voluntariat o dată pe săptămână”. În acest fel, scopul poate fi evaluat.',
  'label.a_achievable': '<b>A-de Atins sau realizabil: Scopul tău trebuie să fie realizabil în perioada de timp specifică programului Award.</b>  În loc să spui ”Vreau să pun capăt sărăciei”, poți seta un scop mai practic, precum: ”Vreau să strâng fonduri cu care să ajut la diminuarea sărăciei dintr-un sat din lumea a treia.”',
  'label.r_realistic': 'R-realist: Acesta este același lucru cu ”de Atins”.</b> Este realist că-ți poți atinge scopul în acea limită de timp?',
  'label.t_timely': 'T-încadrat în Timp: Scopul ar trebui să includă data la care vrei să-l atingi. </b> Scopul tău poate fi:”Vreau să stăpânesc gama La Minor la vioară în trei luni de zile”.',
  'label.you_can_upload_here_any_files': 'Poți încărca aici orice fișier dorești să împărtășești cu Liderul tău.',
  'moduleTitle.login_change': 'Schimbă autentificarea',
  'notifications.adventurous_journey_modified': 'Aventura a fost modificată',
  'tabs.sections': 'Secțiuni',
  'label.change_email': 'Schimbă Email',
  'title.change_email': 'Schimbă Email',
  'label.new_email': 'Email nou',
  'label.new_email_again': 'Confirmă email nou',
  'errors.emails_dont_match': 'Adresele de email nu se potrivesc',
  'button.change_email': 'Schimbă Email',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Un email cu instrucțiuni a fost trimis pe adresa ta',
  'global.dofe_name': 'The Duke of Edinburgh’s Award',
  'global.or': 'sau',
  'route.landing_page': 'Pagina de destinație',
  'route.dashboard': 'Bord',
  'moduleTitle.notifications': 'Notificări',
  'moduleTitle.no_notifications': 'Nicio notificare',
  'moduleTitle.new_notifications': 'Notificări noi',
  'moduleTitle.older_notifications': 'Notificări vechi',
  'moduleTitle.user_guide': 'Ghidurile utilizatorului',
  'label.user_guide': 'Ghidurile utilizatorului',
  'notifications.your_password_has_been_changed': 'Parola ta a fost schimbată',
  'label.country': 'Țara',
  'label.on_your_smartphone': 'Pe Smartphone-ul tău',
  'label.on_the_web': 'Pe web',
  'label.orb_online': 'ORB online',
  'label.language': 'Limba',
  'moduleTitle.participant_login': 'Autentificare participant',
  'label.for_ios': 'pentru iOS',
  'label.for_android': 'pentru Android',
  'button.login_as_award_staff': 'Autentifică-te ca Angajat Award',
  'errors.leader_doesnt_exist': 'Liderul nu există',
  'global.loading': 'Se încarcă...',
  'moduleTitle.award_staff_login': 'Autentificare ca Angajat Award',
  'formTitle.residential_project_details': 'Detalii Proiect Rezidențial',
  'label.you_can_also_download_participant': 'Poți descărca noua noastră aplicație pentru participanți <strong>Participant app</strong> pentru a accesa Online Record Book oriunde, oricând.',
  'label.you_can_also_download_leader': 'Poți descărca noua noastră aplicație pentru lideri <strong>Award Leader app</strong> pentru a accesa Online Record Book oriunde, oricând.',
  'notifications.this_role_is_not': 'Acest rol nu este suportat momentan',
  'notifications.residential_project_has_been_updated': 'Proiectul Rezidențial a fost actualizat',
  'tabs.participant': 'Participant',
  'tabs.award_staff': 'Angajat Award',
  'moduleTitle.edit_residential_project': 'Editează Proiect Rezidențial',
  'button.residential_project': 'Editează Proiect Rezidențial',
  'notifications.your_login_email_has_been_changed': 'Email-ul tău de autentificare a fost modificat',
  'meta.dofe_name': 'The Duke of Edinburgh’s Award',
  'notifications.unknown_role_leader': 'Rol necunoscut - Autentifică-te ca Angajat Award',
  'notifications.unknown_role_participant': 'Rol necunoscut - Autentifică-te ca Participant',
  'label.user_guide_web_participant': 'Ghid utilizator - Participant',
  'label.user_guide_app_participant': 'Ghid utilizator aplicație - Participant',
  'label.note_for_supervisor': 'Mesaj pentru Supraveghetor',
  'label.before_submitting_your_aj': 'Înainte de a trimite Aventura ta Liderului Award, ai nevoie de aprobare de la {role}. Dacă dorești, poți adăuga un mesaj personal.',
  'button.back_to_home': 'Înapoi Acasă',
  'moduleTitle.assessor_approval': 'Aprobare {role}',
  'label.this_aj_has_no_assessor': 'Această călătorie nu are {role}. Trebuie să actualizezi detaliile înainte de o trimite la aprobare.',
  'route.not_found': 'Nu este găsit',
  'notifications.are_you_sure': 'Ești sigur?',
  'button.cancel': 'Anulare',
  'label.add_document': 'Adaugă document',
  'errors.there_are_currently_no_details_for_your': 'Momentan nu sunt detalii pentru {role}. Te rugăm completează detaliile lipsă înainte de a trimite Activitatea pentru evaluare.',
  'moduleTitle.missing_data': 'Date lipsă',
  'label.to_send_assessment_request': 'Dacă dorești să trimiți o cerere de evaluare electronic, te rugăm să introduci email-ul {role}.',
  'label.pending_changes': 'Modificări în așteptare...',
  'label.some_fields_require': 'Câteva câmpuri necesită atenția ta',
  'roles.assessor': 'Evaluator',
  'roles.supervisor': 'Supraveghetor',
  'pageTitle.register_participant': 'Înregistrare participant',
  'moduleTitle.revise_message': 'Revizuiește mesajul',
  'moduleTitle.payment_for_level': 'Plată pentru {awardLevel}',
  'moduleTitle.payment': 'Plata taxei de înregistrare a participantului',
  'moduleTitle.we_have_sent_you_payment_link': 'Ți-am trimis un e-mail cu un link către Payment Gateway.',
  'label.required_award_payment': 'Plată program necesară',
  'label.payment_fees': 'Taxa de plată',
  'label.payment_method': 'Metoda de plată',
  'label.you_will_type_trans_id': 'Vi se va cere să introduceți ID-ul tranzacției',
  'label.any_level_previously': 'Alt nivel anterior finalizat',
  'label.registering_for_level': 'Înregistrare pentru nivel',
  'notification.payment_link_expired': 'Link-ul plății a expirat',
  'button.pay': 'Plătește',
  'label.registration_updated': 'Înregistrarea a fost actualizată',
  'label.award_leader_receive_payment': 'Liderul Award va primi informații despre plată',
  'errors.end_date_after': 'Data de încheiere trebuie să fie după data de începere',
  'button.back': 'Înapoi',
  'button.edit_info': 'Editare informații',
  'moduleTitle.level_detail': 'Detalii nivel',
  'label.payment_methods': 'Modalități de plată',
  'label.address': 'Adresă',
  'note.review_filled_participant': 'Consultați informațiile completate de participant. Dacă găsiți unele incorecte, le puteți edita.',
  'moduleTitle.payment_successful': 'Plata înregistrării participantului a fost făcută cu succes',
  'button.proceed_to_login': 'Continuați să vă conectați',
  'label.add_additional_activity': 'Adaugă activitate adițională',
  'moduleTitle.welcome_to_orb': 'Bine ai venit la Online Record Book!',
  'empty_dashboard.not_approved': 'Aceast intrument te va ajuta să înregistrezi progresul tău în programul Award. Dar profilul tău nu a fost aprobat încă de către Liderul tău Award. Înainte să începi să creezi prima ta activitate, trebuie să aștepți aprobarea.',
  'empty_dashboard.approved_1': 'Acest instrument te va ajuta să înregistrezi progresul tău în programul Award.',
  'empty_dashboard.approved_2': 'Pentru început trebuie să setezi o activitate. Ca să începi, dă click pe o activitate din stânga. Dacă ai nevoie de ajutor pentru setarea activității, întreabă-ți Liderul Award.',
  'label.discuss_activity_leader': 'Dacă selectezi mai multe activități, te rugăm să discuți despre acest lucru cu Liderul tău Award.',
  'label.cannot_add_activity': 'Poți adăuga maxim 3 activități la această categorie. Te rugăm să discuți despre asta cu Liderul tău Award.',
  'button.ok': 'Ok',
  'label.payment_was_canceled': 'Plata a fost anulată de către utilizator',
  'label.problem_with_payment': 'A apărut o problemă la procesarea plății. Te rugăm contactează Biroul Național Award.',
  'pageTitle.register_leader': 'Înregistrare Lider',
  'pageTitle.registration_complete': 'Înregistrare finalizată',
  'label.payment_link_expired_or_paid': 'Ați plătit deja  taxele pentru înregistrarea plății SAU legătura de plată a expirat',
  'label.contact_nao_assistance': 'Contactează Biroul Național dacă ai nevoie de ajutor.',
  'label.send_required_amount_to_your_award_leader': 'Trimite suma recomandată către Liderul Award sau Coordonatorul Award din unitatea ta',
  'label.fee_can_be_paid': 'Taxa poate fi plătită online folosind VISA, Master Card sau cardul de debit sau de credit.',
  'notifications.login_failed_right_tab': 'Autentificare nereușită. Asigurați-vă că sunteți în câmpul adecvat (Participant / Personal Award)',
  'label.i_have_read_privacy_policy': 'Am citit și sunt de acord cu Politicile de Confidențialitate',
  'errors.invalid_date_format': 'Format dată invalid',
  'label.no_privacy_policy': 'Puteți merge mai departe apăsând butonul terminare',
  'label.status': 'Situație',
  'moduleTitle.attached_with_observation': 'Anexat cu mesajul',
  'moduleTitle.revise_message_rp': 'Proiectul tău Rezidențial a fost revizuit de Liderul tău Award.',
  'file.activity_section_summary': '{section}-secțiune-sumar',
  'label.download_section_summary': 'Descarcă sumarul secțiunii',
  'label.award_summary': 'Sumar Program Award',
  'btn.download_summary_for_assessor': 'Descarcă sumarul pentru evaluator',
  'label.first_activity_started': 'Prima activitate începută',
  'label.hours_completed_required': 'Ore finalizate/necesare',
  'label.weeks_completed_required': 'Săptămâni finalizate/necesare',
  back_to_home: 'Înapoi acasă',
  'label.activity_rejected_click': 'Activitatea ta a fost respinsă de Liderul Award. Dă click pentru ',
  'button.more_information': 'mai multe informații',
  'label.attached_file': 'Fișier anexat',
  'moduleTitle.journey_details': 'Detalii călătorie',
  'tabs.activity': 'Activitate',
  'label.confirm_email': 'Confirmă email',
  'label.aj_rejected_click': 'Călătoria ta a fost respinsă de Liderul tău Award. Dă click pentru ',
  'label.verifying_payment': 'Se verifică plata',
  'button.finish_and_pay': 'Finalizează și plătește',
  'label.payment_not_successful_text': 'Deoarece nu ați finalizat cu success plata programului, este necesar să faceși plata acum.',
  'label.payment_not_completed': 'Plată nefinalizată',
  'button.pay_now': 'Plătiți acum',
  'label.registration_pending_parental_consent': 'Înregistrarea dumneavoastră așteaptă Acordul părintelui / tutorelui',
  'button.edit_observation': 'Editează observații',
  'moduleTitle.qualifying': 'Călătorie finală',
  'moduleTitle.practice': 'Călătorie de Antrenament',
  'label.first_log_entry': 'Prima intrare a notei de jurnal',
  'label.first_log_entry_date': 'Data primei intrări a notei de jurnal',
  'label.last_log_entry': 'Ultima intrare a notei de jurnal',
  'label.last_log_entry_date': 'Data ultimei intrări a notei de jurnal',
  'label.you_can_send_journey_report_for_approval': 'Poți trimite raportul Călătoriei {journey} pentru aprobare.',
  'button.edit_and_resend_report': 'Editează și retrimite raport',
  'label.your_journey_is_complete': 'Călătoria ta  {journeyType} este finalizată.',
  'button.add_additional_journey': 'Adaugă călătorie adițională',
  'moduleTitle.edit_journey': 'Editează călătorie',
  'notifications.assessment_sent': 'Evaluarea a fost trimisă',
  'notifications.file_is_too_big': 'Fișierul nu a putut fi încărcat. Probabil este prea mare.',
  'notifications.authorization_code_has_expired': 'Codul de autorizare pentru securitate a expirat. Vă rugăm cereți un nou cod.',
  'route.confirm_email': 'Confirmare e-mail',
  'label.assessor_needs_account': 'Pentru a lucra în Online Record Book (ORB), aveți nevoie e un cont ORB. <br/> Vă rugăm să introduceți detaliile pentru contul dvs. aici.',
  'label.company_name': 'Numele companiei',
  'label.secondary_email_again': 'Confirmă e-mail secundar',
  'label.how_many_years': 'Câți ani/luni?',
  'label.no_company_leave_empty': 'Dacă nu lucrați pentru nici o companie, lăsați liber',
  'label.secondary_phone_number': 'Număr de telefon secundar',
  'label.secondary_phone_type': 'Tipul telefonului secundar',
  'label.wwc_application_number': '',
  'label.wwc_expiration_date': '',
  'label.you_are_now_registering_as_assessor': 'Acum vă înregistrați pentru a deveni Evaluator',
  'label.you_have_finished_aj_now_send_to_approval': 'Ai finalizat secțiunea de Aventură. Acum o poți trimite Evaluatorului pentru aprobare. Poți să adaugi un mesaj personal mai jos.',
  'label.your_experience': 'Experiența dvs.',
  'label.your_qualification': 'Calificările dvs.',
  'notifications.waiting_for_assessor_approval': 'Aprobarea evaluatorului în așteptare',
  'button.resend_assessment_request': 'Trimite cererea de evaluare din nou',
  'errors.emails_must_be_different': 'E-mail-ul secundar trebuie să fie diferit de cel principal',
  'moduleTitle.company_details': 'Detaliile companiei',
  'notifications.already_resent_assessment_request': 'Ați retrimis deja cererea de evaluare',
  'route.assessor_dashboard': '',
  'pageTitle.register_assessor': 'Înregistrează Evaluator',
  'wizard.assessor_details': 'Detaliile Evaluatorului',
  'wizard.assessor_experience': 'Experiența Evaluatorului',
  'wizard.personal_details': 'Detalii personale',
  'button.sign_off': 'Aprobare definitivă',
  'button.sign_off_dashed': 'Aprobare definitivă',
  'moduleTitle.sign_off': 'Aprobare definitivă',
  'label.certify_participant_met_reqs': 'Ca Evaluator al acestei activități, confirm că participantul a îndeplinit cerințele Award.',
  'label.assessor_report': 'Raport evaluator',
  'label.content_update': 'Vă rugăm așteptați. Conținutul se actualizează...',
  'label.comment_on_participant_improvement': 'Vă rugăm spuneți câteva cuvinte despre dedicarea participantului și performanțele obținute',
  'note.edit_participant_review': 'Pentru a corecta informațiile curente, vă rugăm dați click pe butonul Editează informațiile',
  'errors.min_age': 'Vârsta min este {age}',
  'notifications.assessor_link_expired': 'Link-ul de înregistrare a evaluatorului a expirat',
  'label.secondary_email': 'E-mail secundar',
  'moduleTitle.review_participant_info': 'Revizuiește informațiile participantului',
  'label.loading_payment_gateway': 'Portalul de plată se încarcă',
  'label.consent_given_login_as_child': 'Consimțământul a fost deja dat. Vă rugăm să vă autentificați cu contul copilului dvs.',
  'notifications.only_one_qualification_journey_per_award': 'Numai o călătorie finală poate fi setată în Award',
  'label.registration_fees_participant': 'Plata taxei de înregistrare - {name} (#{id})',
  'moduleTitle.leader_details': 'Detaliile Liderului',
  'label.leader_name': 'Numele Liderului',
  'label.leader_phone': 'Numărul de telefon al Liderului',
  'label.leader_email': 'E-mail-ul Liderului',
  'moduleTitle.au_details': 'Detaliile Unității Award',
  'label.au_name': 'Numele Unității Award',
  'label.assessor_guidelines': '',
  'label.assessor_cond_req': 'Cerințe și condiții cheie',
  'label.assessor_ref_handbook': 'Referință la manualul Award',
  'label.assessor_ref_online_modules': 'Referință la modulele de învățare online',
  'label.participant_has_no_aj_report': 'Participantul nu a transmis încă un raport',
  'moduleTitle.participant_details': 'Detaliile participantului',
  'label.participants_has_no_logs': 'Participantul încă nu are note de jurnal',
  'label.location_type': 'Tipul locației',
  'label.activity_ready_for_signoff': 'Această activitate este gata pentru aprobarea finală',
  'label.activities': 'Activități',
  'label.choose_how_you_want_to_login': 'Alege modalitatea de autentificare:',
  'roles.leader': 'Lider',
  'roles.award_verifier': 'Verificator Award',
  'roles.coordinator': 'Coordonator',
  'roles.aj_assessor': 'Evaluator secțiunea Aventură',
  'roles.aj_supervisor': 'Supraveghetor secțiunea Aventură',
  'roles.instructor': 'Instructor',
  'roles.nao_staff': 'Personal ANA',
  'roles.super_user': 'Super-utilizator',
  'roles.user': 'Utilizator',
  'roles.viewer': '',
  'roles.authorizing_contact': 'Contact de autorizare',
  'roles.if_staff_superuser': 'Superuser personal FI',
  'roles.if_staff_statistical_user': 'Utilizator statisticFI',
  'roles.if_staff_viewer': '',
  'roles.aj_instructor': 'Instructor Aventură',
  'label.if_you_have_questions_au': 'Dacă aveți întrebări privind înregistrarea dvs., vă rugăm contactați Unitatea dvs. Award',
  'label.we_will_send_you_an_email_leader': 'Vă vom trimite un e-mail când contul dvs. ORB va fi aprobat.',
  'moduleTitle.rejecting_assessor_invitation': 'Respinge invitația de a deveni evaluator',
  'notifications.assessor_invitation_rejected': 'Invitația de a deveni evaluator a fost respinsă',
  'moduleTitle.participants_list_is_empty': 'Lista participanților este goală',
  'label.note_from_participant': 'Mesaj de la participant',
  'label.you_can_send_aj_to_leader': 'Poți trimite secțiunea de Aventură pentru a fi aprobată de Liderul Award',
  'button.save_report': 'Salvează raport',
  'label.this_activity_has_no_assessor': 'Această activitate nu are evaluator. Trebuie să adaugi detaliile evaluatorului tău înainte de a o trimite pentru aprobare.',
  'label.activity_rejected_click_by_assessor': 'Activitatea ta a fost respinsă de evaluator. Dă click pentru ',
  'button.reject': 'Respinge',
  'button.reject_invitation': 'Respinge invitația',
  'label.reason': 'Motiv',
  'label.accept_invitation_and_continue': 'Acceptă invitația și continuă',
  'pageTitle.registration_reject': 'Respingere înregistrare',
  'errors.you_must_be_older_than_register_for_leader': 'Trebuie să ai peste {years} ani și {months} luni  pentru a te înregistra ca Lider Award.',
  'label.your_report_approve_now_send_to_leader_without_note': 'Raportul tău a fost aprobat! Îl poți trimite Liderului Award pentru aprobare.',
  'button.stop_assessing_this_activity': 'NU MAI EVALUA ACEASTĂ ACTIVITATE',
  'button.confirm': 'Confirmă',
  'moduleTitle.are_you_sure': 'Sunteți sigur?',
  'label.content_restore': 'Restaurare conținut',
  'button.stop_editing': 'Stopează editarea',
  'notifications.activity_has_been_rejected': 'Activitatea a fost respinsă',
  'notifications.aj_has_been_rejected': 'Aventura a fost respinsă',
  'notifications.rp_has_been_rejected': 'Proiectul rezidențial a fost respins',
  'moduleTitle.additional_files': 'Fișiere adiționale',
  'moduleTitle.no_additional_files': 'Fișiere adiționale',
  'moduleTitle.stop_assessing_section': 'Nu mai evalua secțiunea',
  'label.show_security_and_refund_policy': 'Arată politica de securitate și rambursare',
  'moduleTitle.security_and_refund_policy': 'Politica de securitate și rambursare',
  'label.fees_payment': 'Plata taxelor',
  'label.redund_policy': 'Politica de rambursare',
  'label.security_policy': 'Politica de securitate',
  'label.leave_blank': 'Lasă gol',
  'label.frequently_asked_questions': 'Întrebări frecvente (IF)',
  'label.language_selection_is_disabled_for_iac': 'Selectarea limbii nu este activată pentru CIA ',
  'errors.min_nights_required': 'Un minim de {nights} noapte/nopți este necesar',
  'label.completion_date': 'Data finalizării',
  'label.you_are_offline': 'Sunteți offline. Schimbările făcute acum nu vor fi salvate.',
  'errors.start_date_after_award_start': 'Data de început nu poate fi anterioaraă începerii programului curent.',
  'label.participants': 'Participanți',
  'label.marketing_from_iaf': 'Optați pentru primirea de materiale promoționale de la Fundația Internațională.',
  'label.marketing_from_oa': 'Optați pentru primirea de materiale promoționale de la Autoritatea Operațională.',
  'label.marketing_from_nao': 'Optează pentru primirea de materiale promoționale de la ANA',
  'label.select_iac': 'Selectează Centrul Independent Award',
  'label.you_will_be_redirected_to_the_paypal_payment': '',
  'notifications.report_has_been_sent': '',
  'label.processing_paypal_payment': '',
  'label.loading_paypal_gateway': '',
  'label.payment_failed': '',
  'label.payment_has_been_cancelled': '',
  'roles.naa_oa_staff': '',
  'label.download_report_and_upload_signed_version': '',
  'button.download_summary_for_assessor': '',
  'label.pay_online_mastercard': '',
  'label.pay_online_paypal': '',
  'notifications.authorization_code_is_missing': '',
  'errors.unknown_payment_error': '',
  'errors.already_in_use_by_auth_contact': '',
  'roles.if_staff_stat_user': '',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': '',
  'announcement.survey_button.if_over_25': '',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': '',
  'button.see_more_details': '',
  'label.the_cookie_settings_on_this': ''
}
